var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"10px","height":"auto"}},[_c('iframe',{ref:"mainFrame",attrs:{"id":"mainFrame","name":"mainFrame","src":"http://175.27.191.97:8088/","scrolling":"no","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }